import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const items = [
  {
    id: 1,
    name: 'Nature 1',
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb',
  },
  {
    id: 2,
    name: 'Nature 2',
    image: 'https://images.unsplash.com/photo-1519985176271-adb1088fa94c',
  },
  {
    id: 3,
    name: 'Nature 3',
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470',
  },
  {
    id: 4,
    name: 'Nature 4',
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb',
  },
  {
    id: 5,
    name: 'Nature 5',
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470',
  },
];

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Box sx={{ width: '100%', padding: '0', margin: '0' }}>
      <Slider {...settings}>
        {items.map((item) => (
          <Box
            key={item.id}
            sx={{
              padding: '0 5px',
              boxSizing: 'border-box',
            }}
          >
            <img
              src={`${item.image}?auto=format&fit=crop&w=800&q=60`}
              alt={item.name}
              style={{
                width: '100%',
                height: '420px',
                display: 'block',
                objectFit: 'cover',
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Carousel;
